import TableHeader from './TableHeader';

export default TableHeader;



// WEBPACK FOOTER //
// ./src/views/components/Common/Table/TableHeader/index.js